// Работа с куками ->
if (typeof Cookies === "function") {
    var cookie = {
        get: function (key) {
            return Cookies.get(key);
        },
        set: function (key, value, expire) {
            return Cookies.set(key, value, {expires: expire, path: '/'});
        }
    };
} // <- Работа с куками

// debounce
function debounce(fn, delay) {
    var timer = null;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}

function getModal(name) {
    return $.ajax({
        type: 'GET',
        url: window.location.origin + '/ajax_popup/',
        cache: false,
        data: {
            view: name
        }
    }).success(function (response) {
        const modalId = $(response).attr('id');
        $($('body')).append(response)
        initIMask($(`#${modalId}`).find('input.js-input-phone')[0])
        const modalButton = document.querySelector('[data-popup-view="' + name + '"]')
        setTimeout(function () {
            window.dispatchEvent(
                new CustomEvent('modalFetched')
            )
        }, 1)
        if (modalButton) {
            const modalId = modalButton.dataset.popup
            initForms(modalId + ' .js-form')
        }
    })
}

// jQuery depended ->
(function (jq) {
    'use strict';
    // Объект jQuery как параметр
    jq(jQuery, window, document);
}(function ($, window, document) {
    // document ready ->
    'use strict';
    $(function () {
        // Здесь код зависимый от DOM.ready ->
        // Частоиспользуемые элементы
        var $body = $("body"),
            $html = $("html"),
            $document = $(document),
            $window = $(window);

        // Проверяем поля форм, где вводится текст на пустоту ->
        var $formInput = $('input:not([type="checkbox"]), textarea', 'form'),
            isTextInputChanged = function (input) {
                if (input.tagName === "textarea") {
                    return $.trim(input.val()) !== "";
                } else {
                    return $.trim(input.value) !== "";
                }
            },

            inputChangedClass = "changed";

        if ($formInput.length) {
            $formInput.each(function () {
                var $thisInput = $(this);
                isTextInputChanged(this) ? $thisInput.addClass(inputChangedClass) : $thisInput.removeClass(inputChangedClass);
                $thisInput.on({
                    keyup: function () {
                        isTextInputChanged(this) ? $thisInput.addClass(inputChangedClass) : $thisInput.removeClass(inputChangedClass);
                    },
                    change: function () {
                        isTextInputChanged(this) ? $thisInput.addClass(inputChangedClass) : $thisInput.removeClass(inputChangedClass);
                    },
                    blur: function () {
                        isTextInputChanged(this) ? $thisInput.addClass(inputChangedClass) : $thisInput.removeClass(inputChangedClass);
                    }
                });
            });
        } // <- Проверяем поля форм, где вводится текст на пустоту

        // Слайдер на главной ->
        var $mainSlider = $("#main-slider");
        if ($mainSlider.length) {
            var autoPlay = $mainSlider.data('mode') === 'auto';
            if (autoPlay) {
                var speed = parseInt($mainSlider.data('speed'));
                autoPlay = {
                    delay: speed
                }
            }
            var $mainSliderContainer = $(".slider", $mainSlider),
                mainSlider = new Swiper($mainSliderContainer, {
                    slideClass: "slider-slide",
                    slideActiveClass: "active",
                    wrapperClass: "slider-slides",
                    navigation: {
                        nextEl: $(".next", $mainSlider),
                        prevEl: $(".prev", $mainSlider),
                        disabledClass: "disabled"
                    },
                    pagination: {
                        el: $(".slider-dots", $mainSlider),
                        bulletClass: "slider-dot",
                        bulletActiveClass: "active",
                        hiddenClass: "disabled",
                        clickable: true
                    },
                    autoplay: autoPlay,
                    autoHeight: true,
                    speed: 450,
                    longSwipesMs: 400,
                    loop: true,
                    simulateTouch: true,
                    roundLengths: true,
                    on: {
                        'init': function () {
                            if (this.slides.length > 1) {
                                $(".slider-dots", $mainSlider).addClass("use");
                            }
                        }
                    }
                });
        }
        // <- Слайдер на главной

        // // Слайдер почему мы на главной ->
        var $mainWhy = $("#main-why-we");
        if ($mainWhy.length) {
            var $thisSliderContainer = $(".slider", $mainWhy),
                staffSlider = new Swiper($thisSliderContainer, {
                    slideClass: "slider-slide",
                    slideActiveClass: "active",
                    wrapperClass: "slider-slides",
                    spaceBetween: '100%',
                    navigation: {
                        nextEl: $(".next", $mainWhy),
                        prevEl: $(".prev", $mainWhy),
                        disabledClass: "disabled"
                    },
                    pagination: {
                        el: $(".slider-dots", $mainWhy),
                        bulletClass: "slider-dot",
                        bulletActiveClass: "active",
                        clickable: true
                    },
                    speed: 450,
                    longSwipesMs: 400,
                    loop: true,
                    roundLengths: true,
                    watchOverflow: true,
                    on: {
                        'init': function () {
                            if (this.slides.length > 1) {
                                $(".slider-dots", $mainWhy).addClass("use");
                            }
                        }
                    }
                });
        }
        // <- Слайдер почему мы на главной

        // Слайдер изображений для типички ->
        $(window).on("load", function () {
            var $imageSliders = $(".image-slider");
            if ($imageSliders.length) {
                $imageSliders.each(function () {
                    var $thisSlider = $(this),
                        $thisSliderContainer = $(".slider", $thisSlider),
                        thisSliderName = "imageSlider-" + $imageSliders.index($thisSlider);

                    window[thisSliderName] = new Swiper($thisSliderContainer, {
                        wrapperClass: "slider-slides",
                        slideClass: "slider-slide",
                        slideActiveClass: "active",
                        autoHeight: true,
                        navigation: {
                            nextEl: $(".next", $thisSlider),
                            prevEl: $(".prev", $thisSlider),
                            disabledClass: "disabled"
                        },
                        pagination: {
                            el: $(".slider-dots", $thisSlider),
                            bulletClass: "slider-dot",
                            bulletActiveClass: "active"
                        },
                        speed: 450,
                        longSwipesMs: 400,
                        simulateTouch: false,
                        roundLengths: true,
                        watchOverflow: true,
                        on: {
                            'init': function () {
                                if (this.slides.length > 1) {
                                    $(".slider-dots", $thisSlider).addClass("use");
                                }
                            }
                        }
                    });
                });
            } // <- Слайдер изображений для типички
        })


        // Слайдер результатов ->
        var $treatmentResultSliders = $(".treatment-results-slider, #main-treatment-results");
        if ($treatmentResultSliders.length) {
            $treatmentResultSliders.each(function () {
                var $thisSlider = $(this),
                    $thisSliderContainer = $(".slider", $thisSlider),
                    thisSliderName = "treatmentsResultsSlider" + $treatmentResultSliders.index($thisSlider);

                window[thisSliderName] = new Swiper($thisSliderContainer, {
                    slideClass: "slider-slide",
                    slideActiveClass: "active",
                    wrapperClass: "slider-slides",
                    autoHeight: true,
                    navigation: {
                        nextEl: $(".next", $thisSlider),
                        prevEl: $(".prev", $thisSlider),
                        disabledClass: "disabled"
                    },
                    pagination: {
                        el: $(".slider-dots", $thisSlider),
                        bulletClass: "slider-dot",
                        bulletActiveClass: "active"
                    },
                    speed: 450,
                    loop: true,
                    simulateTouch: false,
                    allowTouchMove: false,
                    touchMoveStopPropagation: false,
                    roundLengths: true,
                    watchOverflow: true,
                    on: {
                        'init': function () {
                            if (this.slides.length > 1) {
                                $(".slider-dots", $thisSlider).addClass("use");
                            }
                        }
                    }
                });
            });

            // Сравнение ->
            var dragging = false,
                scrolling = false,
                resizing = false,
                handleClass = ".treatment-results-handle",
                beforeClass = ".treatment-results-before",
                labelClass = ".treatment-results-image-label";
            //cache jQuery objects
            var imageComparisonContainers = $('.treatment-results-slide');
            // Проверим наличие сравнивалки во вьюпорте,
            // если попадает — анимируем

            function animateDraggedHandle(pageX, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
                if (isNaN(xPosition)) {
                    xPosition = 0;
                }
                var leftValue = pageX + xPosition - dragWidth;
                // Держим таскалку внутри контейнера
                if (leftValue < minLeft) {
                    leftValue = minLeft;
                } else if (leftValue > maxLeft) {
                    leftValue = maxLeft;
                }

                var widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth) + '%';

                $('.draggable').css('left', widthValue).on("mouseup vmouseup touchend", function () {
                    $(this).removeClass('draggable');
                    resizeElement.removeClass('resizable');
                    $('.draggable').off("mouseup vmouseup touchend");
                });

                $('.resizable').css('width', widthValue);

                updateLabel(labelResizeElement, resizeElement, 'left');
                updateLabel(labelContainer, resizeElement, 'right');
                dragging = false;
            }

            function checkPosition(container) {
                container.each(function () {
                    var actualContainer = $(this);
                    actualContainer.addClass('is-visible');
                });

                scrolling = false;
            }

            // Функциональность таскаемости (http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/)
            function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
                var dragWidth = dragElement.outerWidth(),
                    containerOffset = container.closest('.slider').offset().left,
                    xPosition = dragElement.offset().left + dragWidth,
                    containerWidth = container.outerWidth(),
                    minLeft = containerOffset + 78,
                    maxLeft = containerOffset + containerWidth - dragWidth - 78;

                $(window).on('resize', function () {
                    dragWidth = dragElement.outerWidth();
                    containerOffset = container.closest('.slider').offset().left;
                    containerWidth = container.outerWidth();
                    minLeft = containerOffset + 78;
                    maxLeft = containerOffset + containerWidth - dragWidth - 78;
                });
                dragElement.on("mousedown vmousedown touchstart", function (e) {
                    dragElement.addClass('draggable');
                    resizeElement.addClass('resizable');

                    xPosition = dragElement.offset().left + dragWidth - e.clientX;

                    dragElement.parents().on("mousemove vmousemove touchmove", function (e) {
                        var pageX = e.pageX;
                        if (!pageX && pageX !== 0) {
                            pageX = e.originalEvent.changedTouches[0].pageX;
                        }

                        if (!dragging) {
                            dragging = true;
                            (!window.requestAnimationFrame)
                                ? setTimeout(function () {
                                    animateDraggedHandle(pageX, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
                                }, 100)
                                : requestAnimationFrame(function () {
                                    animateDraggedHandle(pageX, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
                                });
                        }
                    }).on("mouseup vmouseup touchend", function (e) {
                        dragElement.parents().off("mousemove vmousemove touchmove");
                        dragElement.removeClass('draggable');
                        resizeElement.removeClass('resizable');
                    });
                    e.preventDefault();
                }).on("mouseup vmouseup touchend", function (e) {
                    dragElement.removeClass('draggable');
                    resizeElement.removeClass('resizable');
                });
            }

            function updateLabel(label, resizeElement, position) {
                if (position == 'left') {
                    (label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth()) ? label.removeClass('is-hidden') : label.addClass('is-hidden');
                } else {
                    (label.offset().left > resizeElement.offset().left + resizeElement.outerWidth()) ? label.removeClass('is-hidden') : label.addClass('is-hidden');
                }
            }

            function checkLabel(container) {
                container.each(function () {
                    var actual = $(this);
                    updateLabel(actual.find(labelClass + '[data-type="before"]'), actual.find(beforeClass), 'left');
                    updateLabel(actual.find(labelClass + '[data-type="after"]'), actual.find(beforeClass), 'right');
                });

                resizing = false;
            }


            checkPosition(imageComparisonContainers);
            $(window).on('scroll', function () {
                if (!scrolling) {
                    scrolling = true;
                    (!window.requestAnimationFrame)
                        ? setTimeout(function () {
                            checkPosition(imageComparisonContainers);
                        }, 100)
                        : requestAnimationFrame(function () {
                            checkPosition(imageComparisonContainers);
                        });
                }
            });

            // Делаем таскалку таскаемой, а картику «после» зависимой от позиции таскалки
            imageComparisonContainers.each(function () {
                var actual = $(this);
                drags(actual.find(handleClass), actual.find(beforeClass), actual, actual.find(labelClass + '[data-type="after"]'), actual.find(labelClass + '[data-type="before"]'));
            });

            // Обновляем видимость подписей
            $(window).on('resize', function () {
                if (!resizing) {
                    resizing = true;
                    (!window.requestAnimationFrame)
                        ? setTimeout(function () {
                            checkLabel(imageComparisonContainers);
                        }, 100)
                        : requestAnimationFrame(function () {
                            checkLabel(imageComparisonContainers);
                        });
                }
            });


            // <- Сравнение
        } // <- Слайдер результатов

        // // Слайдер специалистов на главной ->
        // var $mainStaff = $("#main-staff");
        // if ($mainStaff.length) {
        //   var $thisSliderContainer = $(".slider", $mainStaff),
        //     staffSlider = new Swiper($thisSliderContainer, {
        //       slideClass: "slider-slide",
        //       slideActiveClass: "active",
        //       wrapperClass: "slider-slides",
        //       autoHeight: true,
        //       spaceBetween: '100%',
        //       navigation: {
        //         nextEl: $(".next", $mainStaff),
        //         prevEl: $(".prev", $mainStaff),
        //         disabledClass: "disabled"
        //       },
        //       pagination: {
        //         el: $(".slider-dots", $mainStaff),
        //         bulletClass: "slider-dot",
        //         bulletActiveClass: "active"
        //       },
        //       speed: 450,
        //       longSwipesMs: 400,
        //       loop: true,
        //       simulateTouch: false,
        //       roundLengths: true,
        //       watchOverflow: true,
        //       on: {
        //         'init': function () {
        //           if (this.slides.length > 1) {
        //             $(".slider-dots", $mainStaff).addClass("use");
        //           }
        //         }
        //       }
        //     });
        // } // <- Слайдер специалистов на главной

        // Слайдер отзывов на главной ->
        var $mainTestimonials = $("#main-testimonials");
        if ($mainTestimonials.length) {
            var $thisSliderContainer = $(".slider", $mainTestimonials),
                testimonialsSlider = new Swiper($thisSliderContainer, {
                    slideClass: "slider-slide",
                    slideActiveClass: "active",
                    wrapperClass: "slider-slides",
                    autoHeight: true,
                    spaceBetween: '100%',
                    navigation: {
                        nextEl: $(".next", $mainTestimonials),
                        prevEl: $(".prev", $mainTestimonials),
                        disabledClass: "disabled"
                    },
                    pagination: {
                        el: $(".slider-dots", $mainTestimonials),
                        bulletClass: "slider-dot",
                        bulletActiveClass: "active",
                        clickable: true
                    },
                    speed: 450,
                    longSwipesMs: 400,
                    loop: true,
                    simulateTouch: true,
                    roundLengths: true,
                    watchOverflow: true,
                    on: {
                        'init': function () {
                            if (this.slides.length > 1) {
                                $(".slider-dots", $mainTestimonials).addClass("use");
                            }
                        }
                    }
                });
        } // <- Слайдер отзывов на главной

        // Слайдер отзывов на странице конкретной услуги ->
        var $servicesTestimonials = $("#services-testimonials");
        if ($servicesTestimonials.length) {
            var $thisSliderContainer = $(".slider", $servicesTestimonials),
                testimonialsSlider = new Swiper($thisSliderContainer, {
                    slideClass: "slider-slide",
                    slideActiveClass: "active",
                    wrapperClass: "slider-slides",
                    autoHeight: true,
                    spaceBetween: '100%',
                    navigation: {
                        nextEl: $(".next", $servicesTestimonials),
                        prevEl: $(".prev", $servicesTestimonials),
                        disabledClass: "disabled"
                    },
                    pagination: {
                        el: $(".slider-dots", $servicesTestimonials),
                        bulletClass: "slider-dot",
                        bulletActiveClass: "active",
                        clickable: true
                    },
                    speed: 450,
                    longSwipesMs: 400,
                    loop: true,
                    simulateTouch: true,
                    roundLengths: true,
                    watchOverflow: true,
                    on: {
                        'init': function () {
                            if (this.slides.length > 1) {
                                $(".slider-dots", $servicesTestimonials).addClass("use");
                            }
                        }
                    }
                });
        } // <- Слайдер отзывов на странице конкретной услуги

        // Слайдер лицензий на странице услуг
        var $safelySlider = $(".safely");
        var safelySlider

        function createSliderSafely() {
            $thisSliderContainer = $(".slider.safely-slider", $safelySlider),
                safelySlider = new Swiper($thisSliderContainer, {
                    slideClass: "slider-slide",
                    slideActiveClass: "active",
                    wrapperClass: "slider-slides",
                    autoHeight: true,
                    spaceBetween: '100%',
                    pagination: {
                        el: $(".safely-slider-dots", $safelySlider),
                        bulletClass: "slider-dot",
                        bulletActiveClass: "active"
                    },
                    speed: 450,
                    longSwipesMs: 400,
                    watchOverflow: true,
                    simulateTouch: false,
                    on: {
                        'init': function () {
                            if (this.slides.length > 1) {
                                $(".safely-slider-dots", $safelySlider).addClass("use");
                            }
                        }
                    }
                });
        }

        if ($safelySlider.length > 0 && window.innerWidth <= 479) {
            createSliderSafely()
        }

        // Слайдер услуг на стрице услуг
        var $benefitsSlider = $(".benefits");
        var benefitsSlider

        function createSliderBenefits() {
            $thisSliderContainer = $(".slider.benefits-slider", $benefitsSlider),
                benefitsSlider = new Swiper($thisSliderContainer, {
                    slideClass: "slider-slide",
                    slideActiveClass: "active",
                    wrapperClass: "slider-slides",
                    autoHeight: true,
                    spaceBetween: '100%',
                    pagination: {
                        el: $(".benefits-slider-dots", $benefitsSlider),
                        bulletClass: "slider-dot",
                        bulletActiveClass: "active"
                    },
                    speed: 450,
                    longSwipesMs: 400,
                    simulateTouch: false,
                    watchOverflow: true,
                    on: {
                        'init': function () {
                            if (this.slides.length > 1) {
                                $(".benefits-slider-dots", $benefitsSlider).addClass("use");
                            }
                        }
                    }
                });
        }

        if ($benefitsSlider.length > 0 && window.innerWidth <= 479) {
            createSliderBenefits()
        }

        window.addEventListener('resize', function (e) {
            const width = window.innerWidth;
            if (width <= 479) {
                if (!safelySlider && $safelySlider.length > 0) {
                    createSliderSafely()
                }
                if (!benefitsSlider && $benefitsSlider.length > 0) {
                    createSliderBenefits()
                }
            } else {
                if (safelySlider && safelySlider.initialized) {
                    safelySlider.destroy(false, true)
                    safelySlider = null
                }
                if (benefitsSlider && benefitsSlider.initialized) {
                    benefitsSlider.destroy(false, true)
                    benefitsSlider = null
                }
            }
        })

        // Галерея ->
        var $galleries = $(".gallery-album-items, .content-gallery-items, .docs-gallery-items, .safely__licences");
        if ($galleries.length) {
            $galleries.lightGallery({
                selector: 'div',
            });
        }
        // <- Галерея


        // Попапы ->
        var $overlay = $("#overlay"),
            $popupClose = $(".js-popup-close");
        if ($overlay.length) {
            var overlayState = 0,
                overlayShowClass = 'show',
                overlay = {
                    show: function () {
                        overlayState = 1;
                        $overlay.addClass(overlayShowClass);
                    },
                    hide: function () {
                        overlayState = 0;
                        $overlay.removeClass(overlayShowClass);
                    },
                    toggle: function () {
                        if (overlayState === 0) {
                            overlay.show();
                        } else {
                            overlay.hide();
                        }
                    }
                };
        }

        function showOverlay() {
            var baseWidth = $window.width();

            overlay.show();
            $html.addClass("popup-open").css({"padding-right": $window.width() - baseWidth + "px"});
            $scrollToTop.css({"right": $window.width() - baseWidth + 20 + "px"});
        }

        document.addEventListener('click', function (e) {
            const target = e.target;
            if (target.closest('.js-popup-trigger')) {
                e.preventDefault();
                const parent = target.closest('.js-popup-trigger');
                window._TURBO_FORM_ADDITIONAL = this.dataset;
                const attr = (!!$(parent).attr('data-popup') && $(parent).attr('data-popup').trim()) || (!!$(parent).attr('href') && $(parent).attr('href').trim());
                if ($(attr).length) {
                    popup.currentPopup = $(attr);
                    checkPopupHiddenText($(target.closest('.js-popup-trigger')), popup)
                    popup.show();
                    return
                }
                const popupViewAttr = (!!$(parent).attr('data-popup-view') && $(parent).attr('data-popup-view').trim());
                showOverlay();
                if (popupViewAttr) {
                    getModal(popupViewAttr).success(function (response) {
                        popup.currentPopup = $(attr);
                        popup.show();
                    }).fail(function (error) {
                        alert(error);
                    });
                }
            }

            if (target.closest('.js-popup-swap-trigger')) {
                e.preventDefault();
                const parent = target.closest('.js-popup-swap-trigger');
                window._TURBO_FORM_ADDITIONAL = this.dataset;
                const attr = (!!$(parent).attr('data-popup') && $(parent).attr('data-popup').trim()) || (!!$(parent).attr('href') && $(parent).attr('href').trim());
                if ($(attr).length) {
                    popup.swap($(attr));
                    return
                }
                const popupViewAttr = (!!$(parent).attr('data-popup-view') && $(parent).attr('data-popup-view').trim());
                if (popupViewAttr) {
                    getModal(popupViewAttr).success(function (response) {
                        popup.swap($(attr));
                    }).fail(function (error) {
                        alert(error);
                    });
                }
            }
        })

        var popupState = 0,
            popupShowClass = 'show',
            popupHidingClass = 'hiding',
            popup = {
                currentPopup: null,
                show: function () {
                    var baseWidth = $window.width();

                    popupState = 1;
                    popup.currentPopup.addClass(popupShowClass);
                    overlay.show();
                    $html.addClass("popup-open").css({"padding-right": $window.width() - baseWidth + "px"});
                    $scrollToTop.css({"right": $window.width() - baseWidth + 20 + "px"});
                    // Фокус в первое поле формы
                    if (popup.currentPopup.is('[id$="-form"]')) {
                        popup.currentPopup.find("input").eq(0).trigger("focus");
                    }
                },
                hide: function () {
                    popup.sendEvent('popup:close', popup.currentPopup.attr('id'))
                    popupState = 0;
                    popup.currentPopup.addClass(popupHidingClass);
                    setTimeout(function () {
                        popup.currentPopup.removeClass(popupShowClass).removeClass(popupHidingClass);
                        popup.currentPopup = $('.popup.show')
                        if (!popup.currentPopup.length) {
                            $html.removeClass("popup-open").removeAttr("style");
                            _calculateScrollbarWidth()
                            overlay.hide();
                            $scrollToTop.removeAttr("style");
                        }
                    }, 250);
                },
                sendEvent: function (event, data) {
                    const customEvent = new CustomEvent(event, {
                        detail: {
                            data: data,
                        },
                    });
                    window.dispatchEvent(customEvent)
                },
                swap: function (targetPopup) {
                    popupState = 1;
                    popup.currentPopup.addClass(popupHidingClass);
                    setTimeout(function () {
                        popup.currentPopup.removeClass(popupShowClass).removeClass(popupHidingClass);
                        targetPopup.addClass(popupShowClass);
                        popup.currentPopup = targetPopup;
                    }, 250);
                },
                toggle: function () {
                    if (popupState === 0) {
                        popup.currentPopup.show();
                    } else {
                        popup.currentPopup.hide();
                    }
                    overlay.toggle();
                }
            };
        window._popup = popup
        // esc popup close
        $(document).keydown(function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode === 27 && overlayState === 1) {
                popup.hide();
            }
        });

        $('.js-popup-ajax').each(function () {
            $(this).on('click', function (e) {
                const link = $(e.target).closest('.js-popup-ajax').attr('data-link')
                console.log(link);
                $.ajax({
                    type: 'GET',
                    url: window.location.origin + link,
                    cache: false
                }).done(function (response) {
                    const elementToReplace = $('body').find('.' + $(response).attr('class').replace(' ', '.'))
                    elementToReplace.remove()
                    $(response).insertAfter($('main'));
                    popup.currentPopup = $('.result-item-ajax.popup')
                    popup.show()
                    $('.treatment-results-slide img').each(function () {
                        this.height = 500
                        this.width = 500
                        this.addEventListener('load', function () {
                            $('.treatment-results-slide img').each(function () {
                                this.removeAttribute('height')
                                this.removeAttribute('width')
                            })
                        })
                    })
                    initSliderResults()
                }).fail(function (error) {
                    alert(error);
                });
            })
        })

        function initSliderResults() {
            var $treatmentResultSliders = $(".treatment-results-slider, #main-treatment-results");
            if ($treatmentResultSliders.length) {
                $treatmentResultSliders.each(function () {
                    var $thisSlider = $(this),
                        $thisSliderContainer = $(".slider", $thisSlider),
                        thisSliderName = "treatmentsResultsSlider" + $treatmentResultSliders.index($thisSlider);

                    window[thisSliderName] = new Swiper($thisSliderContainer, {
                        slideClass: "slider-slide",
                        slideActiveClass: "active",
                        wrapperClass: "slider-slides",
                        autoHeight: true,
                        navigation: {
                            nextEl: $(".next", $thisSlider),
                            prevEl: $(".prev", $thisSlider),
                            disabledClass: "disabled"
                        },
                        pagination: {
                            el: $(".slider-dots", $thisSlider),
                            bulletClass: "slider-dot",
                            bulletActiveClass: "active"
                        },
                        speed: 450,
                        loop: true,
                        simulateTouch: false,
                        allowTouchMove: false,
                        touchMoveStopPropagation: false,
                        roundLengths: true,
                        watchOverflow: true,
                        on: {
                            'init': function () {
                                if (this.slides.length > 1) {
                                    $(".slider-dots", $thisSlider).addClass("use");
                                }
                            }
                        }
                    });
                });

                // Сравнение ->
                var dragging = false,
                    scrolling = false,
                    resizing = false,
                    handleClass = ".treatment-results-handle",
                    beforeClass = ".treatment-results-before",
                    labelClass = ".treatment-results-image-label";
                //cache jQuery objects
                var imageComparisonContainers = $('.treatment-results-slide');
                // Проверим наличие сравнивалки во вьюпорте,
                // если попадает — анимируем

                function animateDraggedHandle(pageX, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
                    if (isNaN(xPosition)) {
                        xPosition = 0;
                    }
                    var leftValue = pageX + xPosition - dragWidth;
                    // Держим таскалку внутри контейнера
                    if (leftValue < minLeft) {
                        leftValue = minLeft;
                    } else if (leftValue > maxLeft) {
                        leftValue = maxLeft;
                    }

                    var widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth) + '%';

                    $('.draggable').css('left', widthValue).on("mouseup vmouseup touchend", function () {
                        $(this).removeClass('draggable');
                        resizeElement.removeClass('resizable');
                        $('.draggable').off("mouseup vmouseup touchend");
                    });

                    $('.resizable').css('width', widthValue);

                    updateLabel(labelResizeElement, resizeElement, 'left');
                    updateLabel(labelContainer, resizeElement, 'right');
                    dragging = false;
                }

                function checkPosition(container) {
                    container.each(function () {
                        var actualContainer = $(this);
                        // if ($(window).scrollTop() + $(window).height() * 0.5 > actualContainer.offset().top) {
                        actualContainer.addClass('is-visible');
                        // }
                    });

                    scrolling = false;
                }

                // Функциональность таскаемости (http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/)
                function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
                    var dragWidth = dragElement.outerWidth(),
                        containerOffset = container.closest('.slider').offset().left,
                        xPosition = dragElement.offset().left + dragWidth,
                        containerWidth = container.outerWidth(),
                        minLeft = containerOffset + 78,
                        maxLeft = containerOffset + containerWidth - dragWidth - 78;

                    $(window).on('resize', function () {
                        dragWidth = dragElement.outerWidth();
                        containerOffset = container.closest('.slider').offset().left;
                        containerWidth = container.outerWidth();
                        minLeft = containerOffset + 78;
                        maxLeft = containerOffset + containerWidth - dragWidth - 78;
                    });
                    dragElement.on("mousedown vmousedown touchstart", function (e) {
                        dragElement.addClass('draggable');
                        resizeElement.addClass('resizable');

                        xPosition = dragElement.offset().left + dragWidth - e.clientX;

                        dragElement.parents().on("mousemove vmousemove touchmove", function (e) {
                            var pageX = e.pageX;
                            if (!pageX && pageX !== 0) {
                                pageX = e.changedTouches[0].pageX;
                            }

                            if (!dragging) {
                                dragging = true;
                                (!window.requestAnimationFrame)
                                    ? setTimeout(function () {
                                        animateDraggedHandle(pageX, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
                                    }, 100)
                                    : requestAnimationFrame(function () {
                                        animateDraggedHandle(pageX, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
                                    });
                            }
                        }).on("mouseup vmouseup touchend", function (e) {
                            dragElement.parents().off("mousemove vmousemove touchmove");
                            dragElement.removeClass('draggable');
                            resizeElement.removeClass('resizable');
                        });
                        e.preventDefault();
                    }).on("mouseup vmouseup touchend", function (e) {
                        dragElement.removeClass('draggable');
                        resizeElement.removeClass('resizable');
                    });
                }

                function updateLabel(label, resizeElement, position) {
                    if (position == 'left') {
                        (label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth()) ? label.removeClass('is-hidden') : label.addClass('is-hidden');
                    } else {
                        (label.offset().left > resizeElement.offset().left + resizeElement.outerWidth()) ? label.removeClass('is-hidden') : label.addClass('is-hidden');
                    }
                }

                function checkLabel(container) {
                    container.each(function () {
                        var actual = $(this);
                        updateLabel(actual.find(labelClass + '[data-type="before"]'), actual.find(beforeClass), 'left');
                        updateLabel(actual.find(labelClass + '[data-type="after"]'), actual.find(beforeClass), 'right');
                    });

                    resizing = false;
                }


                checkPosition(imageComparisonContainers);
                $(window).on('scroll', function () {
                    if (!scrolling) {
                        scrolling = true;
                        (!window.requestAnimationFrame)
                            ? setTimeout(function () {
                                checkPosition(imageComparisonContainers);
                            }, 100)
                            : requestAnimationFrame(function () {
                                checkPosition(imageComparisonContainers);
                            });
                    }
                });

                // Делаем таскалку таскаемой, а картику «после» зависимой от позиции таскалки
                imageComparisonContainers.each(function () {
                    var actual = $(this);
                    drags(actual.find(handleClass), actual.find(beforeClass), actual, actual.find(labelClass + '[data-type="after"]'), actual.find(labelClass + '[data-type="before"]'));
                });

                // Обновляем видимость подписей
                $(window).on('resize', function () {
                    if (!resizing) {
                        resizing = true;
                        (!window.requestAnimationFrame)
                            ? setTimeout(function () {
                                checkLabel(imageComparisonContainers);
                            }, 100)
                            : requestAnimationFrame(function () {
                                checkLabel(imageComparisonContainers);
                            });
                    }
                });


                // <- Сравнение
            } // <- Слайдер результатов
        }

        // popup close
        var $popupCloseTrigger = $(".js-popup-close");
        if ($popupClose.length) {
            $popupCloseTrigger.on("click", function (e) {
                popup.hide();
                e.preventDefault();
            });
        }

        document.addEventListener('mousedown', function (e) {
            const target = e.target;
            if (target.classList.contains('popup') || target.closest('.js-popup-close')) {
                popup.hide();
                e.preventDefault();
            }
        })

        $(".js-location-popup-close").on("click", function (e) {
            $('#location-choice').removeClass('show');
            e.preventDefault();
        });

        function checkPopupHiddenText(triggerButton, popup) {
            const hiddenText = triggerButton.attr('data-popup-hidden-text')
            const hiddenTextInput = popup.currentPopup.find('.js-popup-hidden-text')

            if (hiddenTextInput && hiddenText) {
                hiddenTextInput.val(hiddenText)
            }
        }

        // Добавим пару вариантов для $.easing ->
        $.extend($.easing, {
            def: 'easeOutQuad',
            swing: function (x, t, b, c, d) {
                return $.easing[$.easing.def](x, t, b, c, d);
            },
            easeOutQuad: function (x, t, b, c, d) {
                return -c * (t /= d) * (t - 2) + b;
            },
            easeInOutQuad: function (x, t, b, c, d) {
                if ((t /= d / 2) < 1) {
                    return c / 2 * t * t + b;
                }
                return -c / 2 * ((--t) * (t - 2) - 1) + b;
            }
        }); // <- Добавим пару вариантов для $.easing


        // Ссылка «Наверх» - >
        var $scrollToTop = $(".js-scroll-2-top");
        if ($scrollToTop.length) {
            var $sideColContent = $('.side-col-content');
            var $header = $('.header')
            var distanceHeaderAndContent = $header.height() + 20;
            var $footer = $("#footer"),
                footerHeight = 0,
                scrollValue = 0,
                showingState = 0,
                showingClass = "show",

                checkScrollToTop = function () {
                    footerHeight = $footer.height();
                    scrollValue = window.pageYOffset;

                    if (scrollValue >= window.innerHeight / 2) {
                        // turn ON
                        if (showingState === 0) {
                            showingState = 1;
                            $scrollToTop.addClass(showingClass);
                        } else {
                            // turn ON
                            showingState = 1;
                            $scrollToTop.addClass(showingClass).removeAttr("style");
                        }
                    } else {
                        // turn OFF
                        if (showingState === 1) {
                            showingState = 0;
                            $scrollToTop.removeClass(showingClass).removeAttr("style");
                            $sideColContent.css('top', distanceHeaderAndContent + 'px')
                        } else {
                            // turn OFF
                            showingState = 0;
                            $scrollToTop.removeClass(showingClass).removeAttr("style");
                            $sideColContent.css('top', distanceHeaderAndContent + 'px')
                        }
                    }
                };


            $(window).on({
                scroll: function () {
                    debounce(checkScrollToTop(), 1000);
                },
                resize: function () {
                    debounce(checkScrollToTop(), 1000);
                }
            });

            checkScrollToTop();

            $scrollToTop.on({
                click: function (e) {
                    $("html, body").stop().animate({scrollTop: 0}, 700, "easeInOutQuad", function () {
                        $scrollToTop.focusout();
                    });
                    e.preventDefault();
                }
            });
        } // <- Ссылка «Наверх»


        // Всякие штуки для главного меню ->
        var $mainMenu = $("#main-menu");
        if ($mainMenu.length) {
            var $menuItems_lvl2 = $mainMenu.find(".item-lvl2");
            $menuItems_lvl2.each(function () {
                var $thisItem = $(this);
                if ($thisItem.find(".items-lvl3").length) {
                    $thisItem.addClass("nested");
                }
            });
            $menuItems_lvl2.hover(
                function () {
                    $(this).addClass("hovered");
                },
                function () {
                    $(this).removeClass("hovered");
                }
            );
        }// <- Всякие штуки для главного меню

        // Всякие штуки для таблиц в контенте ->
        var $contentTables = $("table", ".text");

        if ($contentTables.length) {
            $contentTables.each(function () {
                $(this).wrap('<div class="table-wrap">');
            });
        } // <- Всякие штуки для таблиц в контенте

        // Табы ->
        var $tabs = $(".tabs");
        if ($tabs.length) {
            var $tabItems = $(".tab-item", $tabs),
                $tabLinks = $(".tab-link", $tabs),
                $tabsContent = $(".tabs-content"),
                $tabsContentItems = $(".tabs-content-items", $tabsContent),
                $tabsContentWrappers = $(".tab-content-wrapper", $tabsContent);

            $tabsContentItems.css({"height": $tabsContentWrappers.eq(0).height()});

            $tabLinks.on({
                click: function (e) {
                    var $thisLink = $(this),
                        $thisItem = $thisLink.parents(".tab-item"),
                        thisItemIndex = $tabItems.index($thisItem),
                        tabHeight = $tabsContentWrappers.eq(thisItemIndex).height();

                    $tabsContentItems.css({"height": tabHeight});
                    $tabItems.removeClass("current").filter($thisItem).addClass("current");
                    tabsSwiper.slideTo(thisItemIndex);
                    e.preventDefault();
                }
            });

            var tabsSwiper = new Swiper($tabsContent, {
                slideClass: "tab-content",
                wrapperClass: "tabs-content-items",
                autoHeight: false,
                navigation: false,
                pagination: false,
                speed: 450,
                longSwipesMs: 400,
                loop: false,
                simulateTouch: false,
                roundLengths: true,
                on: {
                    'init': function () {
                        $tabItems.eq(this.realIndex).addClass("current");
                    },
                    'slideChange': function () {
                        $tabItems.removeClass("current");
                        $tabItems.eq(this.realIndex).addClass("current");
                    }
                }
            });
        } // <- Табы
    }); // <- document ready
}));// <- jQuery depended
